import { __assign } from "tslib";
import React from 'react';
import { makeStyles, createStyles, Fade, Tooltip as MuiTooltip, } from '@material-ui/core';
import { getTypographyCSS } from '../../theme/Typography/Typography.utils';
var useStyles = makeStyles(function (theme) {
    return createStyles({
        tooltip: __assign(__assign({ maxWidth: '200px', background: theme.velocity.styling.tooltip.background, color: theme.velocity.styling.tooltip.text, padding: '8px 16px', borderRadius: '2px', textAlign: 'initial' }, getTypographyCSS(theme.velocity, 'text', '100')), { letterSpacing: '0.3px' }),
        // with the arrow this comes down to 4px distance to the element's box
        tooltipPlacementTop: {
            margin: '10px 0',
        },
        tooltipPlacementBottom: {
            margin: '10px 0',
        },
        arrow: {
            color: theme.velocity.styling.tooltip.background,
            '&:before': {
                borderBottomRightRadius: '2px',
            },
        },
    });
});
export var Tooltip = function (_a) {
    var children = _a.children, text = _a.text;
    var classes = useStyles();
    return (React.createElement(MuiTooltip, { classes: classes, title: text, placement: "top", arrow: true, enterTouchDelay: 100, TransitionComponent: Fade, TransitionProps: {
            timeout: {
                enter: 500,
                exit: 250,
            },
        }, PopperProps: {
            popperOptions: {
                modifiers: {
                    preventOverflow: {
                        padding: 16,
                        boundariesElement: 'viewport',
                    },
                },
            },
            // keepMounted: true, // only for debugger purposes
        } }, children));
};
//# sourceMappingURL=Tooltip.js.map